import { formatISO } from 'date-fns';
import { omit } from 'lodash';

import {
  CalculatedWorkDemand,
  CalculatedWorkDemandRow,
  WorkDemandPeriod
} from 'components/types';

import { FunctionColor } from 'components/enums';

import { SaveWorkDemandPayload } from 'RestAPIs/care-demand';

import { WorkDemandForm } from './components/AddEditWorkDemandDialog';

export const sumPeriodTotalsForPeriods = (periods: WorkDemandPeriod[]) =>
  periods.reduce(
    (totals, nextPeriod) => {
      totals.hours += nextPeriod.hours;
      totals.revenue += nextPeriod.revenue;

      return totals;
    },
    { hours: 0, revenue: 0 }
  );

export const getPeriodTotalsForWorkDemandTotals = (
  rows: CalculatedWorkDemandRow[]
): WorkDemandPeriod[] =>
  rows[0].periods.map(({ number }) => {
    const allWithSameNumber = rows
      .map((row) => row.periods.filter((period) => period.number === number))
      .flat();

    return {
      number,
      ...sumPeriodTotalsForPeriods(allWithSameNumber)
    };
  });

export const formatTotalWorkDemandForGraph = (
  workDemand: CalculatedWorkDemand,
  isShowHours: boolean,
  t
) => [
  {
    name: isShowHours ? t('hours') : t('euros'),
    color: FunctionColor.WORK_DEMAND,
    data: getPeriodTotalsForWorkDemandTotals(workDemand.rows).map((totals) =>
      isShowHours ? totals.hours : totals.revenue
    )
  }
];

export const formatWorkDemandDataForSave = (
  workDemand: WorkDemandForm
): SaveWorkDemandPayload =>
  ({
    ...omit(workDemand, [
      'validFrom',
      'validTo',
      'id',
      'hoursPerYear',
      'revenuePerHour',
      'revenuePerYear'
    ]),
    timeframe: {
      from: formatISO(workDemand.validFrom, { representation: 'date' }),
      to: formatISO(workDemand.validTo, { representation: 'date' })
    }
  } as SaveWorkDemandPayload);
